module.exports = __webpack_public_path__ + "fonts/HarmonyOS_Sans_SC_Light.74677b06.ttf";